import {
  faChevronLeft,
  faChevronRight,
  faChevronsLeft,
  faChevronsRight,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Button } from "../button/Button";

import type { CalendarState, RangeCalendarState } from "react-aria-components";

const navigationButtonClassname = "border-none";

interface CalendarControlsProps {
  calendarState: CalendarState | RangeCalendarState;
}

export function PreviousMonthButton({ calendarState }: CalendarControlsProps) {
  return (
    <Button
      aria-label="Previous month"
      className={navigationButtonClassname}
      ghost
      isIconOnly
      onPress={() => calendarState.focusPreviousPage()}
    >
      <FontAwesomeIcon icon={faChevronLeft} />
    </Button>
  );
}

export function NextMonthButton({ calendarState }: CalendarControlsProps) {
  return (
    <Button
      aria-label="Next month"
      className={navigationButtonClassname}
      ghost
      isIconOnly
      onPress={() => calendarState.focusNextPage()}
    >
      <FontAwesomeIcon icon={faChevronRight} />
    </Button>
  );
}

export function PreviousYearButton({ calendarState }: CalendarControlsProps) {
  return (
    <Button
      aria-label="Previous year"
      className={navigationButtonClassname}
      ghost
      isIconOnly
      onPress={() => calendarState.focusPreviousSection(true)}
    >
      <FontAwesomeIcon icon={faChevronsLeft} />
    </Button>
  );
}

export function NextYearButton({ calendarState }: CalendarControlsProps) {
  return (
    <Button
      aria-label="Next year"
      className={navigationButtonClassname}
      ghost
      isIconOnly
      onPress={() => calendarState.focusNextSection(true)}
    >
      <FontAwesomeIcon icon={faChevronsRight} />
    </Button>
  );
}

export function NextCalendarControls({ calendarState }: CalendarControlsProps) {
  return (
    <div className="flex items-center justify-end">
      <NextMonthButton calendarState={calendarState} />
      <NextYearButton calendarState={calendarState} />
    </div>
  );
}

export function PreviousCalendarControls({ calendarState }: CalendarControlsProps) {
  return (
    <div className="flex items-center justify-start">
      <PreviousYearButton calendarState={calendarState} />
      <PreviousMonthButton calendarState={calendarState} />
    </div>
  );
}
